import React, { memo } from 'react';
import DynamicComponent from '../general-components/dynamic-component';

type MediaSelectorProps = {
    type: string;
    [key: string]: any;
};

const MediaSelector = ({ type, ...props }: MediaSelectorProps) => <DynamicComponent props={{ ...props }} type={type} child={<></>}></DynamicComponent>;

export default memo(MediaSelector);
